module.exports = __webpack_public_path__ + "static/media/elbows-quizz.cca4cd30.jpg";